/*
 * サブシステム名：売掛・買掛
 * 機能名：取引先別売掛残高一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'UrikakeZandakaList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      targetType: '',
      seikyusakiCd: ''
    },
    headersNyukinsakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      nyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.urikakeKingakuSumDisp = filter.numericFormatter(elem.urikakeKingakuSum) + '円'
        elem.latestNyukinYmd = [undefined, null, ''].includes(elem.latestNyukinYmd) ? '' : filter.dateFormatter(elem.latestNyukinYmd)
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredTorihikisakiList () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredNyukinsakiList () {
      const target = filter.dateFormatter(new Date())
      return this.nyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
    console.log('xxx created')
  },
  mounted () {
    console.log('xxx mounted')
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    console.log('xxx beforeRouteUpdate')
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'vwcmsttorihikisakigetnyukinsaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('UrikakeZandakaList.defineHeaderPromise')
            self.headers = [
              { text: '詳細', value: 'detailrefchip', sortable: false, width: '20px' },
              { text: '取引先', value: 'seikyusakiNm' },
              { text: '残高合計', value: 'urikakeKingakuSumDisp', align: 'right' },
              { text: '最終入金日', value: 'latestNyukinYmd' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            // URLパラメータ参照
            var wTorihikisakiCd = ''
            const query = self.$route.query
            if (![undefined, null, ''].includes(query.scd)) {
              wTorihikisakiCd = query.scd
            }
            self.conditions = {
              targetType: '0',
              seikyusakiCd: wTorihikisakiCd
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('UrikakeZandakaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('UrikakeZandakaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('UrikakeZandakaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            // self.$set(self.conditions, 'nyukinStartYmdString', self.conditions.nyukinStartYmdString)
            // self.$set(self.conditions, 'nyukinEndYmdString', self.conditions.nyukinEndYmdString)
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('UrikakeZandakaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('UrikakeZandakaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              if (![undefined, null, ''].includes(self.conditions.seikyusakiCd)) {
                self.onSearchButtonClick()
              }
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.conditions.nyukinStartYmdString = '2024/08/01'
            self.HttpClient.post('/api/v1/VwCD2bcld0110/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          /*
          self.rows = []]
          self.rows.push({ torihikisakiNm: '株式会社○○運送', urikakeZandakaGokei: '0', lastNyukinYmd: '2024/07/31' })
          self.rows.push({ torihikisakiNm: '株式会社○×運輸', urikakeZandakaGokei: '0', lastNyukinYmd: '2024/08/20' })
          self.rows.push({ torihikisakiNm: '有限会社△△トランスポート', urikakeZandakaGokei: '1,500,000', lastNyukinYmd: '2024/05/31' })
          self.rows.push({ torihikisakiNm: '株式会社◇◇産業', urikakeZandakaGokei: '3,250,000', lastNyukinYmd: '2024/06/15' })
          self.rows.push({ torihikisakiNm: '××コーポレート', urikakeZandakaGokei: '500,000', lastNyukinYmd: '2024/07/31' })
          self.rows.push({ torihikisakiNm: '凹凸エアカーゴ', urikakeZandakaGokei: '0', lastNyukinYmd: '2024/07/31' })
          */

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              targetType: '0',
              seikyusakiCd: ''
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowDetailButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { seikyusakiId: item.seikyusakiId })
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/VwCD2depd001001/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2depd001001/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    searchValidate: function () {
      console.log('●●searchVaridate:', this.$refs)
      var msg = validators.compareDate(this.conditions.nyukinStartYmdString, this.conditions.nyukinEndYmdString)
      if (msg !== undefined) {
        this.$refs.nyukinStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.nyukinEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    }
  }
}
